//---------	Global imports
import React from 'react';

//---------	Plugins
import { forEach, isNumber } from 'lodash';

//---------	Styles
import './styles.sass';

//---------	Translations
import { T } from '../../../translations';


class ProductActions extends React.Component {
  
  //---------	Constructor
  constructor(props) {
    super();
    
    this.currentPrices = props.currentPrices;
    this.basePrice = props.basePrice;
    this.snipcart = props.snipcart;
    this.snipcart.priceSets = [];
    this.selectedVariants = props.selectedVariants;
    this.variants = props.variants;
    this.upgrade = this.upgrade.bind(this);
  }
  
  
  //---------	React functions
  componentWillReceiveProps(props) {
    this.currentPrices = props.currentPrices;
  }
  
  componentDidMount() {
    this.snipcartData();
  }
  
  
  //---------	Custom functions
  snipcartData() {
    let snipcartData = [];
    
    forEach(this.variants, (variantOptions, variantName) => {
      let currentSetPremium = '',
        currentSetDeluxe = '',
        prices;
      
      forEach(variantOptions, (price, name) => {
        
        if (variantName === 'material') {
          currentSetPremium = '|premium';
          currentSetDeluxe = `|${name}[+${price}]`;
        }
        else {
          
          prices = price.split('|');
          
          if (prices[0] > 0) {
            currentSetPremium += `|${name}[+${prices[0]}]`;
          }
          else {
            currentSetPremium += `|${name}`;
          }
          
          if (prices[1] > 0) {
            currentSetDeluxe += `|${name}[+${prices[1]}]`;
          }
          else {
            currentSetDeluxe += `|${name}`;
          }
        }
      });
      
      snipcartData[variantName] = {
        premium: currentSetPremium.substring(1),
        deluxe: currentSetDeluxe.substring(1)
      };
    });
    this.snipcart.priceSets = snipcartData;
  }
  
  upgrade() {
    this.selectedVariants.material = 'deluxe';
    this.props.upgrade(this.selectedVariants)
  }
  
  
  //---------	Render
  render() {
    
    let isDeluxe = this.selectedVariants.material === 'deluxe';

    return (
      <div className="CalipsyProductActions">
        <div className={isDeluxe ? 'CalipsyProductActions-price is-deluxe' : 'CalipsyProductActions-price'}>
          <div>
            <h3>{T.global.currentPrice}(
              <small>£</small>
              )
            </h3>
            
            <div className="CalipsyProductActions-buttons">
              {this.props.itemIsAdding ? <div className="CalipsyProductActions-addingItem"></div> : null}
              <div>
                <div className="CalipsyProductActions-priceVariants">
                  {
                    !isDeluxe ? (
                      <p className="CalipsyProductActions-priceVariant">
                        <span>{T.global.pricePremium}</span>
                        <strong>{this.currentPrices[0]}</strong>
                        <button className="CalipsyButton CalipsyButton-blue CalipsyButton-addToBasket snipcart-add-item"
                                style={{
                                  display: isDeluxe ? 'none' : 'inline-block'
                                }}
                                id="CalipsyProduct-premium"
                                data-item-id={this.snipcart.id}
                                data-item-price={this.basePrice}
                                data-item-image={'https://calipsy.com' + this.snipcart.thumbnail}
                                data-item-name={this.snipcart.name}
                                data-item-weight={this.snipcart.weight}
                                data-item-description={this.snipcart.description}
                                data-item-url={'https://calipsy.com' + this.snipcart.path}
                                data-item-custom1-name="material"
                                data-item-custom1-options={this.snipcart.priceSets.material ? this.snipcart.priceSets.material.premium : 'premium'}
                                data-item-custom1-value="premium"
                                data-cart-custom1-required="true"
                                data-item-custom2-name="color"
                                data-item-custom2-options={this.snipcart.priceSets.color ? this.snipcart.priceSets.color.premium : ''}
                                data-item-custom2-value={this.selectedVariants.color}
                                data-cart-custom2-required="true"
                                data-item-custom3-name="size"
                                data-item-custom3-options={this.snipcart.priceSets.size ? this.snipcart.priceSets.size.premium : ''}
                                data-item-custom3-value={this.selectedVariants.size}
                                data-cart-custom3-required="true"
                                data-item-custom4-name="pattern"
                                data-item-custom4-options={this.snipcart.priceSets.pattern ? this.snipcart.priceSets.pattern.premium : ''}
                                data-item-custom4-value={this.selectedVariants.pattern}
                                data-cart-custom4-required="true"
                        >{T.global.addToBasket}
                        </button>
                      </p>
                    ) : null
                  }
                  <p className="CalipsyProductActions-priceVariant CalipsyProductActions-priceVariantDeluxe">
                    <span>{T.global.priceDeluxe}</span>
                    <strong>{this.currentPrices[1]}</strong>
                    <button className="CalipsyButton" onClick={this.upgrade}>{T.global.upgradeNow}</button>
                    
                    <button className="CalipsyButton CalipsyButton-blue CalipsyButton-addToBasket snipcart-add-item"
                            style={{
                              display: isDeluxe ? 'inline-block' : 'none'
                            }}
                            id="CalipsyProduct-deluxe"
                            data-item-id={this.snipcart.id}
                            data-item-price={this.basePrice}
                            data-item-image={'https://calipsy.com' + this.snipcart.thumbnail}
                            data-item-name={this.snipcart.name}
                            data-item-weight={this.snipcart.weight}
                            data-item-description={this.snipcart.description}
                            data-item-url={'https://calipsy.com' + this.snipcart.path}
                            data-item-custom1-name="material"
                            data-item-custom1-options={this.snipcart.priceSets.material ? this.snipcart.priceSets.material.deluxe : 'deluxe'}
                            data-item-custom1-value="deluxe"
                            data-cart-custom1-required="true"
                            data-item-custom2-name="color"
                            data-item-custom2-options={this.snipcart.priceSets.color ? this.snipcart.priceSets.color.deluxe : ''}
                            data-item-custom2-value={this.selectedVariants.color}
                            data-cart-custom2-required="true"
                            data-item-custom3-name="size"
                            data-item-custom3-options={this.snipcart.priceSets.size ? this.snipcart.priceSets.size.deluxe : ''}
                            data-item-custom3-value={this.selectedVariants.size}
                            data-cart-custom3-required="true"
                            data-item-custom4-name="pattern"
                            data-item-custom4-options={this.snipcart.priceSets.pattern ? this.snipcart.priceSets.pattern.deluxe : ''}
                            data-item-custom4-value={this.selectedVariants.pattern}
                            data-cart-custom4-required="true"
                    >{T.global.addToBasket}
                    </button>
                  </p>
                </div>
                <i><span>or</span></i>
                <button onClick={this.props.toggleSidebar}
                        className="CalipsyProductActions-customize">{T.global.customize}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductActions;


// WEBPACK FOOTER //
// ./src/components/ProductActions/index.js